"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.powerForesight = void 0;
const powerForesight = exports.powerForesight = {
  POWER_FORESIGHT: {
    en: {
      title: 'ICIS Power Foresight',
      subtitle: 'Stress test strategies and balance risk',
      description: 'Optimise results with European power market intelligence, factoring in carbon, LNG and gas.',
      list: ['Short, medium and long-term forecasts including daily 14-day pricing, supply and demand, driven by over 2 million data points', 'Current and historic pricing data', 'Wholesale and renewable capture prices', 'Transparent models with traceable data and assumptions']
    },
    zh: {
      title: 'ICIS电力预测与分析',
      subtitle: '压力测试战略与风险平衡',
      description: '欧洲电力市场资讯覆盖碳、LNG和天然气行业，优化您的业绩。',
      list: ['基于200多万个数据点，进行短期、中期和长期预测，包括14天日度价格、供应和需求', '当前和历史价格数据', '批发和可再生能源捕获价格', '透明的模型，可追踪的数据和假设']
    }
  }
};